export const SET_CENQ_COLLECTION = 'CENQ/SET_CENQ_COLLECTION';
